import { Component } from "react";
import {
	DKLabel,
	DKButton,
	DKInput,
	showLoader,
	removeLoader,
	showToast,
	TOAST_TYPE
} from "deskera-ui-library";
import Popup from "../common/Popup";
import Utility, { deepClone, getCapitalized } from "../../utility/Utility";
import { REHIRE_EMPLOYEE } from "./employeeConstants";
import moment from "moment";
import EmployeeListService from "../../services/EmployeeListService";
import { CONSTANTS, INPUT_TYPE } from "../../constants/Constant";
import Table from "../../services/table";
import { convertDateToJson } from "../../managers/common/CommonUtil";
import { TENANT, TenantService } from "../../managers/TenantManagerService";

export default class RehireEmployree extends Component {
    formFields = deepClone(REHIRE_EMPLOYEE);
    defaultValues = {};
    canValidate = false;

    constructor(props) {
        super(props);
        this.state = {
            terminationDate: props.data?.rowData?.data?.dateOfTermination,
            userDetails: props.data?.rowData?.data
        }

        if(props.data?.rowData?.data?.userId) {
            this.getEmployeeDetailsDefault(props.data.rowData.data.userId)
        }

        if (TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED)) {
          const idx = this.formFields.findIndex((field) => field.key === "dateOfConfirmation");
          if (idx !== -1) {
            this.formFields[idx].required = false;
          }
        }
    }

    getEmployeeDetailsDefault(userId) {
        showLoader()
        EmployeeListService.getEmployeeDetailsDefault(userId).then(res=>{
            if(res && res.status == "OK") {
                this.setState({
                    ...this.state,
                    userDetails:res.user
                })
            }
        },error=>{
            console.log(error);
        }).finally(()=>{
            removeLoader()
        })
    }

    updateState() {
        this.setState({
            ...this.state
        })
    }

    validateForm() {
        let isValid = true;
        this.canValidate = true;
        this.formFields.forEach(field => {
            if (field.required && field.type != INPUT_TYPE.NUMBER && Utility.isEmpty(this.defaultValues[field.key])) {
                isValid = false;
            } else if (!field.isValid) {
                isValid = false;
            }
        })
        this.updateState();
        return isValid
    }

    onSave = () => {
        setTimeout(()=>{
            if(!this.validateForm()) {
                return;
            }
            showLoader("Saving... Please wait");
            let userObj = this.state.userDetails;
            if(userObj['prevDateOfJoining']) {
                userObj['prevDateOfJoining'].push(this.state.userDetails['dateOfJoining'])
            } else {
                userObj['prevDateOfJoining'] = [this.state.userDetails['dateOfJoining']]
            }

            const param = {
                ...userObj,
                dateOfJoining: this.defaultValues["dateOfJoining"] ? convertDateToJson(this.defaultValues["dateOfJoining"]) : CONSTANTS.EMPTY_STRING,
                dateOfConfirmation: this.defaultValues["dateOfConfirmation"] ? convertDateToJson(this.defaultValues["dateOfConfirmation"]) : CONSTANTS.EMPTY_STRING,
                terminationStage: "",
                isTerminated: false,
                isRehireRequest: true
            }

            if (TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED)) {
                param['isDraft'] = true
            }
            
            Table.updateEmployee(param).then(
                (res) => {
                    showToast('Employee Rehired successfully', TOAST_TYPE.SUCCESS);
                    this.props.onClose(true);
                }, (error) => {
                    if (error?.message && typeof error.message === "string") {
                        showToast(getCapitalized(error.message), TOAST_TYPE.FAILURE);
                    } else {
                        showToast('Internal server error', TOAST_TYPE.FAILURE);
                    }
                }
            ).finally(() => {
                removeLoader();
            });
        },100)
    }

    getFieldValue(obj) {
        if (obj.options && obj.options.length != 0) {
            if (obj.options[0].id) {
                return obj.options.find(o => o.id == this.defaultValues[obj.key])
            } else {
                return obj.options.find(o => o == this.defaultValues[obj.key])
            }
        }
        return this.defaultValues[obj.key];
    }

    onChange(value, index, obj) {
        this.canValidate = true
        this.defaultValues[obj.key] = (value && value.id) ? value.id : value;
        this.updateState()
    }

    renderFormField = (obj, index) => {
        return (
            <>
                <DKInput

                    className={"p-v-s mb-r "}
                    icon={obj.icon}
                    title={obj.name}
                    placeholder={obj.name}
                    value={this.getFieldValue(obj)}
                    options={obj.options}
                    type={obj.type}
                    errorMessage={obj.errorMessage}
                    labelClassName=" text-align-left "
                    canValidate={this.canValidate}
                    onChange={(value) => {
                        this.onChange(value, index, obj);
                    }}
                    validator={(value) => {
                        if (obj.validation && obj.validation.regExp) {
                            const regex = new RegExp(obj.validation.regExp);
                            obj.isValid = regex.test(value);
                            return regex.test(value);
                        } else if (obj.required && typeof value === "string" && Utility.isEmpty(value.trim())) {
                            obj.isValid = false
                            return false;
                        } else if (obj.required && Utility.isEmpty(value)) {
                            obj.isValid = false
                            return false;
                        } else if (!Utility.isEmpty(this.state.terminationDate)) {
                            let DOT = this.state.terminationDate;
                            const selectedDate = moment(value).format();
                            if ( (!moment(selectedDate).isBefore(moment(DOT))) || (moment(selectedDate).isSame(moment(DOT), 'day'))) {
                                if(obj.key === 'dateOfConfirmation') {
                                    let DOJ = moment(this.defaultValues.dateOfJoining).format();
                                    const selectedDate = moment(value).format();
                                    if((!moment(selectedDate).isBefore(moment(DOJ))) || (moment(selectedDate).isSame(moment(DOJ), 'day'))){
                                        obj.isValid = true;
                                        return true;
                                    } else {
                                        obj.isValid = false;
                                        return false;
                                    }
                                } else {
                                    obj.isValid = true;
                                    return true;
                                }
                            } else {
                                obj.isValid = false;
                                return false;
                            }
                        } else {
                            obj.isValid = true;
                            return true;
                        }
                    }}
                    formatter={(obj) => {
                        /** How to render a selected option in case of object **/
                        return (obj && obj.name) ? obj.name : obj;
                    }}
                    dropdownConfig={{
                        className: "",
                        style: {},

                        data: obj.options,
                        renderer: (index, obj) => {
                            /** How to render value in Dropdown in case of object **/
                            return <DKLabel text={`${((obj && obj.name) ? obj.name : obj)}`} />;
                        },
                        onSelect: (index, obj) => {

                        },
                    }}
                    direction={obj.direction}
                    required={obj.required}
                    readOnly={obj.readOnly}
                    tooltip={{
                        content: obj.tooltipText,
                        className: "warning-tooltip-prop",
                      }}
                />
            </>
        )
    }

    renderHeader = () => {
        return (
            <div className="row justify-content-between ">
                <DKLabel text="Rehire Employee" className="fw-b fs-m" />
                <div className="row width-auto">
                    <DKButton title="Cancel" className="bg-gray1 border-m"
                        onClick={() => {
                            this.props.onClose(false);
                        }}
                    />
                    <DKButton title="Save" className="bg-button text-white ml-r"
                        onClick={() => {
                            this.onSave();
                        }}
                    />
                </div>
            </div>
        );
    }

    render() {
        return (
            <Popup popupClass={"popup-overflow"}>
                {this.renderHeader()}
                <div className="parent-width mt-m">
                    {this.formFields.map((field, index) => {
                        return <div className="">{this.renderFormField(field, index)}</div>
                    })}
                </div>
            </Popup>
        )
    }
}
